// extracted by mini-css-extract-plugin
export var locationCard = "_ge-0";